angular.module('unergie.main')
.controller('serviceOrdersCtrl', ($scope, $state, $uibModal, BoFeaturesService, ApiUser, AlertManager, TableGeneratorService, OrganizationService, DownloadService, ErrorCatcher) => {
    $scope.serviceOrders = {
        show: {},
        refreshing: false,
        columns: {
            'id': { label: 'ID', mode: 'search_operator', mandatory: true },
            'id_sequence': { label: 'Numéro', mode: 'search_operator', mandatory: true },
            'status': { label: 'Statut', mode: 'search_wildcard' },
            'id_category': { label: 'Paquet', mode: 'hidden' },
            'category.name': { label: 'Paquet', mode: 'search_wildcard' },
            'category.organization': { label: 'Organisation', mode: 'search_wildcard' },
            'category.account.brand': { label: 'Compte', mode: 'search_wildcard' },
            'id_case': { label: 'Affaire', mode: 'search_wildcard' },
            'id_contract': { label: 'Id contrat', mode: 'search_wildcard' },
            'contractElec.id_prm': { label: 'PDL', mode: 'search_wildcard', length: 14 },
            'type': { label: 'Type', mode: 'search_strict' },
            'file_path': { label: 'PDF', mode: 'search_wildcard' },
            'creation_ts': { label: 'Date de création', mode: 'search_date' },
            'payload': { label: 'Payload', mode: 'hidden' },
            'requester': { label: 'Demandeur', mode: 'search_wildcard' },
        },
    }

    $scope.serviceOrdersType = {
        'service-order-commission': 'Rattachement',
        'service-order-decommission': 'Détachement',
        'service-order-temp-connection': 'Branchement provisoire',
    }

    $scope.serviceOrdersFilter = _.map($scope.serviceOrdersType, (title, id) => ({ id, title }))

    $scope.notNullFilter = [{ id: '!<null>', title: 'Oui' }, { id: '<null>', title: 'Non' }]

    const refresh = () => TableGeneratorService.getTable($scope.serviceOrders, 'service-orders')

    $scope.shootFields = {
        overrideTo: {
            label: `Modifier le destinataire`,
            type: 'checkbox',
        },
        to: {
            hidden: (t) => !t.overrideTo,
            label: `Destinataire`,
            type: 'email',
            required: true,
        },
    }

    $scope.shootTemplate = {
        overrideTo: false,
        to: '',
    }

    $scope.shoot = (so) => {
        so.sending = true
        const payload = $scope.shootTemplate.overrideTo ? { to: $scope.shootTemplate.to } : {}
        return ApiUser.sendServiceOrder({ id: so.id }, payload).$promise.then((result) => {
            AlertManager.success('Ordre de service renvoyé', 6000)
            refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            so.sending = false
        })
    }

    $scope.download = DownloadService.s3Download

    $scope.refresh = refresh
    refresh()
})
